/**
 * Created by neo on 29.05.17.
 */

import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { translate } from 'react-i18next';
import { Card, CardBody, Collapse, Row, Col, Container, Button, FormGroup, Input, Label } from 'reactstrap';
import ClientInfo from '../ClientInfo';
import CheckoutSection from '../CheckoutSection';
import VoucherBookingRequest from '../../Store/Booking/VoucherBookingRequest';
import TextField from '../../Components/Form/TextField';
import Settings from '../../Store/Settings';
import ProcessingModal from '../ProcessingModal';
import moment from 'moment-timezone';
import FlightOffer from '../../Store/FlightOffer';
import type { FlightOfferAircraft } from '../../Store/FlightOffer';
import BookingRequest from '../../Store/Booking/BookingRequest';
import GiftcardCheck from '../../Components/Giftcards/GiftcardCheck';
import { withRouter } from 'react-router';

type Props = {
  params: any
};

@observer
export class VoucherBookingScreen extends Component {

  @observable booking: BookingRequest = new VoucherBookingRequest();

  state: {
    showClientInfo: boolean,
    showCheckout: boolean,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      showClientInfo: true,
      showCheckout: false,
      flightOffer: null,
      offerBooking: null,
    };
  }

  componentWillMount() {
    this.loadOffer();
  }

  loadOffer = async () => {
    const {
      aircraft: aircraftId,
      exclusive,
      passengers,
    } = this.props.location.query;

    const {
      flightOfferId,
    } = this.props.params;

    if (!flightOfferId) {
      this.booking.promo_code = null; // disable promo code if it's a value voucher

      return;
    }

    const flightOffer = await FlightOffer.get(flightOfferId);
    const aircraft = flightOffer.aircraft_offers.find((a: FlightOfferAircraft) => +a.id === +aircraftId) || flightOffer.aircraft_offers[0];
    const offerBooking = new BookingRequest({ flightOffer, exclusive, aircraft });
    offerBooking.setPassengerCount(exclusive === 'true' ? offerBooking.maxPassengers : passengers);

    // for discount calculation
    this.booking.offer_booking = offerBooking;
    this.booking.value = offerBooking.actualPrice;

    this.setState({ flightOffer, offerBooking });
  };

  handleBooking = (token) => {
    const { booking } = this;

    if (token) {
      booking.payment.token = token.id;
    }

    this.setState({ isOpen: true });
  };

  handleModalClose = (success) => {
    if (success) {
      this.props.router.replace('/');
    } else {
      this.setState({
        isOpen: false,
      });
    }
  };

  handleClientInfoNext = () => {
    this.setState({ showClientInfo: false, showCheckout: true });
    // scrollToComponent(this.passengerInfo);
  };

  handleBookingSuccess = (voucher) => {
    this.setState({
      voucher,
    });
  };

  handleBookingError = () => {
    this.setState({
      voucher: null,
    });
  };

  handleNavigation = () => {
    this.props.router.push('/#/');
  };

  render() {
    const { booking } = this;
    const { flightOffer, offerBooking } = this.state;
    const { t, params: { flightOfferId } } = this.props;
    const { settings } = Settings;

    return (
      <Container>
        <Row>
          <Col xs={12}>
            <GiftcardCheck />
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <h1>2. {t('Buy gift certificate')}</h1>
              </Col>
            </Row>
            <Row className='align-items-stretch mb-4'>
              <Col md={6} className='mb-4 mb-md-0'>
                <Card>
                  <CardBody>
                    <h2>1. {t('Buy')}</h2>
                    {flightOfferId ?
                      (flightOffer &&
                        <Row>
                          <Col xs='12' md='6'>
                            {t('Offer')}:
                            <h4>{flightOffer.title}</h4>
                          </Col>
                          <Col xs='12' md='6'>
                            {t('Flugzeug')}:
                            <h4>{offerBooking.aircraft.aircraft_model.name}</h4>
                          </Col>
                          <Col xs='12' md='6'>
                            {t('Anzahl Passagiere')}:
                            <h4>{offerBooking.passengerCount}</h4>
                          </Col>
                          <Col xs='12' md='6'>
                            {t('Pick-up location')}:
                            <h4>{flightOffer.location.name}</h4>
                          </Col>
                        </Row>
                      )
                      :
                      <Row>
                        <Col xs='12' md='6' className='pr-md-0'>
                          <TextField
                            required
                            label={t('Voucher value')}
                            name='voucher_value'
                            onChange={(e) => booking.value = e.target.value}
                            error={!booking.validValue}
                            errorText={t('Voucher value must be a multiple')}
                            value={booking.value}
                            placeholder={t('Enter voucher value')}
                            helperText={t('Voucher value must be a multiple')}
                          />
                        </Col>
                        <Col xs='12' md='2'>
                          <FormGroup>
                            <Label>&nbsp;</Label>
                            <Input plaintext className='h3' value={booking.currency} />
                          </FormGroup>
                        </Col>
                        <Col xs='12' md='4' className='pl-md-0'>
                          <FormGroup>
                            <Label>&nbsp;</Label>
                            <Button className='form-control' block color='primary' onClick={this.handleNavigation}>
                              {t('Choose a specific offer')}
                            </Button>
                          </FormGroup>
                        </Col>
                      </Row>
                    }
                    <Row>
                      <Col>
                        <TextField
                          label={t('Beneficiary name and greeting')}
                          name='note'
                          onChange={(e) => booking.note = e.target.value}
                          value={booking.note}
                          helperText={t('Will be visible on the certificate')}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md={6}>
                <ClientInfo
                  hidePhone
                  hideNote
                  client={booking}
                />
              </Col>
            </Row>
            <Row>
            </Row>
            <Row>
              <Col>
                <CheckoutSection
                  open={this.state.showCheckout}
                  enabled={booking.validClient}
                  booking={booking}
                  handlePayment={this.handleBooking}
                  onToggleCollapse={() => this.setState({ showCheckout: !this.state.showCheckout })}
                  buttonText={t('Buy voucher')}
                />

              </Col>
            </Row>
          </Col>
        </Row>
        <ProcessingModal
          booking={booking}
          isOpen={this.state.isOpen}
          onCloseRequest={this.handleModalClose}
          onSuccess={this.handleBookingSuccess}
          onError={this.handleBookingError}
        >
          {
            this.state.voucher &&
            <div style={{ textAlign: 'center' }}>
              {t('Your voucher code is')}
              <h2>{this.state.voucher.code}</h2>
              {t('Voucher is valid until {{date}}', { date: moment(this.state.voucher.valid_until).format('L') })}
            </div>
          }
        </ProcessingModal>
      </Container>
    );
  }
}

export default withRouter(translate()(VoucherBookingScreen));



// WEBPACK FOOTER //
// ./src/App/Booking/Voucher/index.js